import { Component, OnInit, AfterContentInit, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { first } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from '../_services/environment.service';
import { MsalService, BroadcastService } from "@azure/msal-angular";
import { Subscription } from "rxjs";
import { User } from '../_models/user.model';

import Swal from'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  token: string;
  loading = false;
  error = false;
  returnUrl: string;
  errorMessage = '';
  fullUrl = '';
  employeeType = "";
  rutabase = "";

  private logoutObservable = new BehaviorSubject<boolean>(false);
  logoutObservable$ = this.logoutObservable.asObservable();
  logout = false;

  accountName:any = "";
  isLoggedIn = false;
  passwordResetAuthority = "https://cafamb2c.b2clogin.com/cafamb2c.onmicrosoft.com/B2C_1A_RESET_PASSWORD_RP";
  authority="";
  subscriptions: Subscription[] = [];
  private swalInstance: any;
  datosEmpresa:any = [];
  valorEmpresaSeleccionado: string;
  decodedPayload:any ;
  showModal: boolean = false;

  header: string;
  payload: string;
  signature: string;

  constructor(
    private authB2c: MsalService,
    private broadcastService: BroadcastService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private envService: EnvironmentService,
    private http: HttpClient,
    ) { }


    ngOnInit() {

      this.authService.logout();
      const authUrl = this.getAuth('authURL');
      if (authUrl){
        this.authB2c.authority = this.getAuth('authURL');
      }

      //this.fullUrl = this.envService.cafamLoginURL + this.envService.appReturnURL;
      this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
      const routeParams: Params = this.route.snapshot.queryParams;
      this.handleRedirect();

    }

    openModal() {
      this.showModal = true;
    }

    closeModal() {
      this.showModal = false;
    }

    onLogin(userType) {

      this.employeeType = userType;
      let config = this.authB2c.getCurrentConfiguration();

      switch (userType){
        case 1:
        this.authority = this.envService.authorityEmpresas;
        break;
        case 2:
        this.authority = this.envService.authorityPersonas;
        break;
        case 3:
        this.authority = this.envService.authorityWindows;
        break;
        case 4:
        window.open(this.envService.htmlFormAfiliaEmpleador, '_blank');
        return false;
        break;
        case 5:
        window.open(this.envService.htmlFormAfiliaNoDepende, '_blank');
        return false;
        break;
        default:
        this.authority = 'No molestar';
      }

      Swal.fire({
        title: 'Redirigiendo... ',
        text: 'te estamos redirigiendo hacia la autenticación segura',
        icon: 'info',
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: () => {
          Swal.showLoading()
        }
      });

      // URL que conserva el authority
      this.setAuth('authURL', this.authority);
      this.loading = true;
      this.authB2c.authority = this.authority;
      this.authB2c.loginRedirect();
      //this.authService.logout();

    }

    checkAccount() {

      this.isLoggedIn = !!this.authService.currentUserValue;
      if (this.isLoggedIn) {
        this.accountName = this.authService.currentUserValue.authToken;
        this.router.navigate(['/']);
      } else {
        this.accountName = "";
      }
    }

    setAuth(key: string, value: string): void {
      window.sessionStorage.setItem(key, value);
    }

    getAuth(key: string): string | null {
      return window.sessionStorage.getItem(key);
    }

    removeAuth(key: string): void {
      window.sessionStorage.removeItem(key);
    }

    clearAuth(): void {
      window.sessionStorage.clear();
    }

    // Método para cambiar el valor del observable
    changeLogout(nuevoValor: boolean) {
      this.logoutObservable.next(nuevoValor);
    }

    manejarValorSeleccionado(valorSeleccionado: any) {

      console.log('Valor seleccionado:', valorSeleccionado);
      this.valorEmpresaSeleccionado =  valorSeleccionado;
      this.closeModal();

      console.log(this.valorEmpresaSeleccionado);
      // Modificar los datos que deseas en el cuerpo (payload)
      this.decodedPayload.NumeroIdentificacionEmpleador = this.valorEmpresaSeleccionado; // Cambia el valor deseado
      // Volver a codificar el cuerpo (payload) como Base64
      const encodedPayload = btoa(JSON.stringify(this.decodedPayload));
      // Volver a generar el token con el nuevo cuerpo (payload)
      const newToken = `${this.header}.${encodedPayload}.${this.signature}`;
      this.token = newToken;
      console.log(newToken);
      console.log( this.token);

      this.authService.login(this.token)
      .pipe(first())
      .subscribe(
        user => {
          this.loading = false;
          if (user && user.authToken){
            this.swalInstance.close();
            this.router.navigate([this.returnUrl]);
          } else {
            this.error = true;
            this.errorMessage = 'Autenticación no exitosa';
          }
        },
        error => {

          this.authB2c.logout();
          const errorObject = error as HttpErrorResponse;
          switch (errorObject.status) {
            case 400:
            if (errorObject.error) {
              this.errorMessage = errorObject.error.Message;
            } else {
              this.errorMessage = 'No se pudo obtener una respuesta, intente nuevamente.';
            }
            break;
            case 401:
            this.errorMessage = 'Su usuario no se encuentra autorizado para acceder en este momento.';
            break;
            case 500:
            this.errorMessage = 'Lo sentimos, el servicio no está disponible. Intente más tarde.1';
            break;
            case 503:
            this.errorMessage = 'Lo sentimos, el servicio no está disponible. Intente más tarde.2';
            break;
            default:
            this.errorMessage = 'Lo sentimos, el servicio no está disponible. Intente más tarde.3';
            break;
          }
          this.loading = false;
          this.error = true;
          this.errorMessage = 'Something happened';
        }
      );

    }

    handleRedirect(){

      this.authB2c.handleRedirectCallback( (error, response) => {
        this.swalInstance = Swal.fire({
          title: 'Cargando... ',
          text: 'Estamos perfilando la experiencia de usuario, por favor espera unos segundos',
          icon: 'info',
          allowOutsideClick: false,
          allowEscapeKey: false,
          onOpen: () => {
            Swal.showLoading()
          }
        });

        if (error) {
          console.log(error);
          this.swalInstance.close();
        } else {
          console.log(response);
          this.token = response.idToken.rawIdToken;

          //this.token = "eyJhbGciOiJSUzI1NiIsImtpZCI6IndmRUlKc1pkX0hwWEdDOGsxcWJxMWVmYzJ1dTA0cDJWWU9MQWQ0b2t6ODQiLCJ0eXAiOiJKV1QifQ.eyJ2ZXIiOiIxLjAiLCJpc3MiOiJodHRwczovL2NhZmFtYjJjLmIyY2xvZ2luLmNvbS8zZWIwNmMwNi1jMTQ2LTRkMWMtOGViYS02NWM5NGYwYjRlYWUvdjIuMC8iLCJzdWIiOiIxYjA1NTA3Yy1hNGIzLTQwYmMtYjhlNC01MTQ5YTQyNDZiMjMiLCJhdWQiOiI0YzkxNDJmZS04ZTQ4LTQ0ZTYtYWI5NC1iNmNhMDgzM2FkMjEiLCJleHAiOjE3MDA2ODU1NDQsImFjciI6ImIyY18xYV9zaWduaW5fcnAiLCJub25jZSI6IjdmN2M1MzdjLTYzMTktNDlhMC1hYmVmLTM4NWE3OWE1NGJhOCIsImlhdCI6MTcwMDY4MTk0NCwiYXV0aF90aW1lIjoxNzAwNjgxOTQ0LCJDb3JyZW9FbGVjdHJvbmljb0NvbnRhY3RvQWRtaW5pc3RyYXRpdm8iOiJqdXBnYWxpbmRvQGNhZmFtLmNvbS5jbyIsIlByaW1lckFwZWxsaWRvQ29udGFjdG9BZG1pbmlzdHJhdGl2byI6IkpVQU4iLCJQcmltZXJOb21icmVDb250YWN0b0FkbWluaXN0cmF0aXZvIjoiR0FMSU5ETyIsIkNlbHVsYXJDYSI6Iis1NzMxNTg1NzU5NDgiLCJUaXBvSWRlbnRpZmljYWNpb25FbXBsZWFkb3IiOiJDTzFOIiwiRW1wbG95ZWVUeXBlIjoiRW1wcmVzYSIsIk51bWVyb0lkZW50aWZpY2FjaW9uRW1wbGVhZG9yIjoiODYwMDEzNTcwMyIsIkNsYXNlRGVJbnRlcmxvY3V0b3IiOiJaRU1QIiwiRXN0YWRvRGVsQXBvcnRhbnRlIjoiVklHRU4iLCJUaXBvSWRlbnRpZmljYWNpb25Db250YWN0b0FkbWluaXN0cmF0aXZvIjoiQ08xQyIsIk51bWVyb0lkZW50aWZpY2FjaW9uQ29udGFjdG9BZG1pbiI6Ijc5OTEwNjg3IiwiU2VndW5kb05vbWJyZUNvbnRhY3RvQWRtaW5pc3RyYXRpdm8iOiJQQUJMTyIsInRpZCI6IjNlYjA2YzA2LWMxNDYtNGQxYy04ZWJhLTY1Yzk0ZjBiNGVhZSIsIm5iZiI6MTcwMDY4MTk0NH0.M_zS-XCI6wv45P9AaFA8XQ3yq8tkx9pvVumYZI4WXRtTq_b2WcGJUreqUCimTrD3js8B9fgyuf3k-D8egLeaxjdIFFWhpEAQp1UxIXVej2J2CLkfTLypGu9B-8xf34XpVu-M69bN4j_r60OB2hPdZZqsfzTjBWEekWBW_nqBa6UEocCS3AV2Dnri8vudx4PVPKM-sfwEsgCkEwRHPuNEZiR99ru9m_uEWH5-XV4RjzKPovcw3hZNas10wyRY95vRBdsPjgKgnvzjWhCGAlMwLkM90VN0MAAyXCLgd0x4y2UV1ATS2SDHQY2R4o4CqUYchsYYskxg1ePBPOtF-sU_fg";

          // Decodificar el token en sus partes
          const partes = this.token.split('.');
          if (partes.length === 3) {
            this.header = partes[0];
            this.payload = partes[1].replace("_","/");
            this.signature = partes[2];
          }

          // Decodificar el cuerpo (payload) como JSON
          this.decodedPayload = JSON.parse(atob(this.payload));

          if(this.decodedPayload.EmployeeType === "Empresa"){
            this.openModal();
            this.swalInstance.close();
          }else{

            this.authService.login(this.token)
              .pipe(first())
              .subscribe(
                user => {
                  this.loading = false;
                  if (user && user.authToken){
                    this.swalInstance.close();
                    this.router.navigate([this.returnUrl]);
                  } else {
                    this.error = true;
                    this.errorMessage = 'Autenticación no exitosa';
                  }
                },
                error => {
                  const errorObject = error as HttpErrorResponse;
                  if (errorObject.status !== undefined){
                    switch (errorObject.status) {
                      case 400:
                      if (errorObject.error) {
                        this.errorMessage = errorObject.error.Message;
                      } else {
                        this.errorMessage = 'No se pudo obtener una respuesta, intente nuevamente.';
                      }
                      break;
                      case 401:
                      this.errorMessage = 'Su usuario no se encuentra autorizado para acceder en este momento.';
                      break;
                      case 500:
                      this.errorMessage = 'Lo sentimos, el servicio no está disponible. Intente más tarde.';
                      break;
                      case 503:
                      this.errorMessage = 'Lo sentimos, el servicio no está disponible. Intente más tarde.';
                      break;
                      default:
                      this.errorMessage = 'Lo sentimos, el servicio no está disponible. Intente más tarde.';
                      break;
                    }
                    this.swalInstance.close();
  
                    this.loading = false;
                    this.error = true;
                    //this.errorMessage = 'Something happened';
  
                    this.swalInstance = Swal.fire({
                      title: 'Error ',
                      text: this.errorMessage,
                      icon: 'error',
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      showCancelButton: true,
                      showConfirmButton: false,
                    }).then((result) => {
                      console.log(result)
                    });
                  }
                  else {
                    this.swalInstance.close();
                  }
                  
                }
              );

          }
        }
      });
    }
}
